export const noteTemplate = (title: string) => (_: string, p1: string) => `
  <div class="notice notice--info">
    <div class="notice__title notice--margin">
      <div class="notice__icon notice--margin">
        <svg class="notice--margin" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
          <path d="M16 2H11.82C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM9 1.75C9.41 1.75 9.75 2.09 9.75 2.5C9.75 2.91 9.41 3.25 9 3.25C8.59 3.25 8.25 2.91 8.25 2.5C8.25 2.09 8.59 1.75 9 1.75ZM16 18H2V4H16V18Z" fill="#414141"/>
          <path d="M12.08 10.03L9.96 7.91003L4 13.86V16H6.1L12.08 10.03Z" fill="#414141"/>
          <path d="M13.8499 8.27C14.0499 8.07 14.0499 7.76 13.8499 7.56L12.4399 6.15C12.2399 5.95 11.9299 5.95 11.7299 6.15L10.6699 7.21L12.7899 9.33L13.8499 8.27Z" fill="#414141"/>
        </svg>
      </div>
      <div class="notice__text notice--margin">
        ${title}
      </div>
    </div>
    <div class="notice__message notice--margin">
      ${p1}
    </div>
  </div>
`;

export const shortNoteTemplate = (_: string, p1: string) => `
  <div class="notice notice--info notice--margin">
    <div class="notice__message notice--margin">
      ${p1}
    </div>
  </div>
`;

export const tipTemplate = (title: string) => (_: string, p1: string) => `
  <div class="notice notice--warning">
    <div class="notice__title notice--margin">
      <div class="notice__icon notice--margin">
        <svg class="notice--margin"  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 21C9 21.55 9.45 22 10 22H14C14.55 22 15 21.55 15 21V20H9V21ZM12 2C8.14 2 5 5.14 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.14 15.86 2 12 2ZM14.85 13.1L14 13.7V16H10V13.7L9.15 13.1C7.8 12.16 7 10.63 7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 10.63 16.2 12.16 14.85 13.1Z" fill="#414141"/>
        </svg>
      </div>
      <div class="notice__text notice--margin">
        ${title}
      </div>
    </div>
    <div class="notice__message notice--margin">
      ${p1}
    </div>
  </div>
`;

export const shortTipTemplate = (_: string, p1: string) => `
  <div class="notice notice--warning notice--margin">
    <div class="notice__message notice--margin">
      ${p1}
    </div>
  </div>
`;

export interface ITemplateTitles {
  noteTitle?: string;
  tipTitle?: string;
}

export const templateRender = (text: string, { noteTitle = '', tipTitle = '' }: ITemplateTitles = {}) => text
  .replace(/\{\*note:(.*?)\*\}/gi, noteTemplate(noteTitle))
  .replace(/\{\*short-note:(.*?)\*\}/gi, shortNoteTemplate)
  .replace(/\{\*tip:(.*?)\*\}/gi, tipTemplate(tipTitle))
  .replace(/\{\*short-tip:(.*?)\*\}/gi, shortTipTemplate);
